import getOr from "lodash/fp/getOr";

const selectIsAnalyticsEnabled = getOr(false, [
  "app",
  "formData",
  "enableAnalytics",
]);

export default selectIsAnalyticsEnabled;
